import table from "assets/images/chart-images/table.png";

const associateEditors = [
    { id: "TAEDAER#-T77r", name: "table", chartImage: table, v2: "Column", disabled: false, },
    { id: "TAEDAER#-T20r", name: "table", chartImage: table, v2: "Column", disabled: false, },
];

export default associateEditors;